import { useDebounced } from "./useDebounced";
import { useState } from "react";

export default function useDebouncedState(intialState, delay = 1000) {
  const [valueState, setValueState] = useState(intialState);
  const debouncedValue = useDebounced(valueState, delay);

  return [valueState, setValueState, debouncedValue];
}
